import classnames from 'classnames';

import monochromeSrc from 'src/assets/logo-monochrome.svg';
import iconSrc from 'src/assets/logo.svg';
import wordmarkSrc from 'src/assets/textLogo.svg';

import styles from './Logo.module.scss';
import { Props } from './Logo.types';

const VARIANT_SRC = {
  icon: iconSrc,
  wordmark: wordmarkSrc,
  monochrome: monochromeSrc,
};

const Logo = ({ variant, className, style, width, height, alt = 'Share Heritage' }: Props) => {
  return (
    <img
      src={VARIANT_SRC[variant]}
      alt={alt}
      width={width}
      height={height}
      style={style}
      className={classnames(styles.container, className)}
    />
  );
};

export default Logo;
